"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  balanceOf: {
    inputs: [{
      internalType: "address",
      name: "account",
      type: "address"
    }],
    name: "balanceOf",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  },
  price: {
    inputs: [],
    name: "price",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  },
  decimals: {
    constant: true,
    inputs: [],
    name: "decimals",
    outputs: [{
      name: "",
      type: "uint8"
    }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  symbol: {
    constant: true,
    inputs: [],
    name: "symbol",
    outputs: [{
      name: "",
      type: "string"
    }],
    payable: false,
    stateMutability: "view",
    type: "function"
  },
  WETH: {
    inputs: [],
    name: "WETH",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "pure",
    type: "function"
  },
  token: {
    inputs: [],
    name: "token",
    outputs: [{
      internalType: "contract Erc20",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  },
  allowance: {
    inputs: [{
      internalType: "address",
      name: "owner",
      type: "address"
    }, {
      internalType: "address",
      name: "spender",
      type: "address"
    }],
    name: "allowance",
    outputs: [{
      internalType: "uint256",
      name: "",
      type: "uint256"
    }],
    stateMutability: "view",
    type: "function"
  },
  isApprovedForAll: {
    inputs: [{
      internalType: "address",
      name: "account",
      type: "address"
    }, {
      internalType: "address",
      name: "operator",
      type: "address"
    }],
    name: "isApprovedForAll",
    outputs: [{
      internalType: "bool",
      name: "",
      type: "bool"
    }],
    stateMutability: "view",
    type: "function"
  },
  getApproved: {
    inputs: [{
      internalType: "uint256",
      name: "tokenId",
      type: "uint256"
    }],
    name: "getApproved",
    outputs: [{
      internalType: "address",
      name: "",
      type: "address"
    }],
    stateMutability: "view",
    type: "function"
  }
};
//# sourceMappingURL=standard-abis.js.map